// event-registration-form-app/components/AlertBar.jsx

import React from "react";

const AlertBar = ({ type, title, message = null }) => {
  if (!title && !message) {
    return null;
  }

  const alertClass = ["c-event-registration-form__alert", `c-event-registration-form__alert--${type}`].join(" ");
  const titleClass = ["c-event-registration-form__alert-title", message ? "c-event-registration-form__alert-title--gap" : ""].filter(Boolean).join(" ");
  const messageClass = ["c-event-registration-form__alert-message"].join(" ");

  return (
    <div className={alertClass}>
      {title && <h3 className={titleClass}>{title}</h3>}
      {message && <p className={messageClass}>{message}</p>}
    </div>
  );
};

export default AlertBar;
